import * as Yup from 'yup'
import { SaleOrderProps } from '@/types'

export const schemaSelectSaleOrders = (t: (key: string) => string) => ({
  saleOrders: Yup.mixed().required(t('requiredMessage')),
})

export const checkIfChecked = (values: SaleOrderProps[], uuid: string) => {
  const isChecked = values.find((item) => item.uuid === uuid)

  return !!isChecked
}
